export const COL_12 = {
    components: [],
    width: 12,
    offset: 0,
    push: 0,
    pull: 0,
    size: 'md',
    currentWidth: 12
};
export const COL_6 = {
    ...COL_12,
    width: 6,
    currentWidth: 6
};
export default {
    COL_12,
    COL_6
};
